export default __webpack_public_path__ + "static/char-s-05-cht-1c426898f0f74633bbb53b6b663f67d5.webp";